import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { send } from "@utils/fetch";
import store from "@utils/redux/store";
import { visitorLifecycleStates } from "@utils/constants";
import { captureException } from "src/utils/sentry";

const visitorStatusSlice = createSlice({
  name: "visitorStatus",
  initialState: {} as JsonObject,
  reducers: {
    updateVisitorStatus(state, action: PayloadAction<JsonObject>) {
      return { ...action.payload };
    },
  },
});

export const { updateVisitorStatus } = visitorStatusSlice.actions;

/**
 * Fetches subscriptions by user id and updates the slice (subscriptions and determinations).
 */
export const updateVisitorStatusState = createAsyncThunk(
  "visitorStatus/updateVisitorStatusState",
  async ({ user_id, is_new_user }: JsonObject, thunkAPI) => {
    // eslint-disable-next-line no-console
    console.log("Updating user visitor status");
    const { surveyAnswers } = store.getState();
    let visitorStatus: JsonObject = {};
    try {
      ({ visitorStatus } = await send(
        "POST",
        "/visitor/api/v1/getVisitorStatus/",
        {
          clientUserId: user_id,
          surveyAnswers,
        }
      ));
    } catch (e) {
      captureException(e, "updateVisitorStatusState");
      return;
    }

    // Override backend result if the user was freshly created
    if (is_new_user) {
      // NOTE(Kevin): This code should only be reachable if the user is in an email route
      visitorStatus.visitorState = visitorLifecycleStates.newVisitor;
    }

    thunkAPI.dispatch(
      // eslint-disable-next-line no-use-before-define
      updateVisitorStatus({
        ...visitorStatus,
      })
    );
  }
);

export default visitorStatusSlice.reducer;
